import { Map } from 'immutable';
import { SET_NOTIFICATION, OPEN_NOTIFICATION, CLOSE_NOTIFICATION, SET_CLASSES } from '../actions/notification';


const initialState = Map({
  message: '',
  open: false,
  classes: ''
});

const actionsMap = {
  [SET_NOTIFICATION]: (state, action) => {
    return state.set('message', action.message);
  },
  [SET_CLASSES]: (state, action) => {
    return state.set('classes', action.classes);
  },
  [OPEN_NOTIFICATION]: (state) => {
    return state.set('open', true);
  },
  [CLOSE_NOTIFICATION]: (state) => {
    return state.set('open', false);
  }
};

export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}


// WEBPACK FOOTER //
// ./reducers/notification.js